import trainingAdapter from '@/adapters/training';

export default (el) => ({
  id: String(el.id),
  name: String(el.name || ''),
  companyId: el.company_id ? String(el.company_id) : null,
  sourceId: el.source_id ? String(el.source_id) : null,
  trainings: el.week ? Object.values(el.week).flat().map(trainingAdapter) : [],
  isHidden: el.hidden === '1',
  position: Number(el.sort),
});
